import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Link from 'next/link';
import { NavItem } from './DesktopNavigation';

interface DesktopSubNavigationProps {
  activeSubNav: NavItem | null;
  setActiveSubNav: React.Dispatch<React.SetStateAction<NavItem | null>>;
  pathname: string;
}

export const DesktopSubNavigation: React.FC<DesktopSubNavigationProps> = ({
  activeSubNav,
  setActiveSubNav,
  pathname,
}) => {
  if (!activeSubNav || !activeSubNav.subItems) return null;

  return (
    <AnimatePresence>
      {activeSubNav && (
        <motion.div
          key="subnav"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="absolute w-full top-16 left-0 border-b border-t border-grey-700 z-40 bg-dark-900"
          // Houdt het submenu open als de muis binnen het submenu blijft.
          onMouseEnter={() => setActiveSubNav(activeSubNav)}
          onMouseLeave={() => setActiveSubNav(null)}
        >
          <div className="flex justify-center py-6 max-w-7xl mx-auto">
            <div className="flex flex-row gap-12">
              {activeSubNav.subItems.map((sub) => (
                <Link
                  key={sub.name}
                  href={sub.href}
                  className={`text-base font-fractul transition-colors ${
                    pathname === sub.href
                      ? 'font-bold text-yellow-600'
                      : 'text-grey-200 hover:text-yellow-600'
                  }`}
                >
                  {sub.name}
                </Link>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};